import { PSEVDO_EXPERIMENT_Q3_2023 } from '../../../constants/experiments';
import { IApplicationState } from '../../../types/redux';

/**
 * TODO: Удалить после окончания 3 квартала 2023 в CD-178450
 */
export const psevdoExperiment2023Q3Selector = (state: IApplicationState): boolean => {
  const { abUseExperiments } = state;

  const experiment = abUseExperiments.find(e => e.experimentName === PSEVDO_EXPERIMENT_Q3_2023);

  if (!experiment) {
    return false;
  }

  return !!experiment.groupName;
};
